import { render } from "./FugleTable.vue?vue&type=template&id=41bde56b&scoped=true&ts=true"
import script from "./FugleTable.vue?vue&type=script&lang=ts"
export * from "./FugleTable.vue?vue&type=script&lang=ts"

import "./FugleTable.vue?vue&type=style&index=0&id=41bde56b&lang=scss&scoped=true"
import "./FugleTable.vue?vue&type=style&index=1&id=41bde56b&scoped=true&lang=css"
import "./FugleTable.vue?vue&type=style&index=2&id=41bde56b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bde56b"]])

export default __exports__